import { Permission } from '@today/types'
import type { RouteObject } from 'react-router-dom'
import { RequirePermission } from '@/components/RequirePermission'
import { LocaleSettingsPage, LocaleSettingsRedirect } from './LocaleSettingsPage'
import { ProductCategoriesPage } from './ProductCategoriesPage'
import { ProductEditorPage } from './ProductEditorPage'
import { ProductsListPage } from './ProductsListPage'

/**
 * Product admin routes (TO-416 product-admin-ui REQ-001) — permission-gated;
 * without the permission the Forbidden page renders.
 */

/** Children of the app's `/` layout route. */
export const productPageRoutes: RouteObject[] = [
	{
		path: 'products',
		element: (
			<RequirePermission permission={Permission.PRODUCT_READ}>
				<ProductsListPage />
			</RequirePermission>
		),
	},
	{
		path: 'products/new',
		element: (
			<RequirePermission permission={Permission.PRODUCT_WRITE}>
				<ProductEditorPage />
			</RequirePermission>
		),
	},
	{
		path: 'products/:id',
		element: (
			<RequirePermission permission={Permission.PRODUCT_READ}>
				<ProductEditorPage />
			</RequirePermission>
		),
	},
	{
		path: 'product-categories',
		element: (
			<RequirePermission permission={Permission.PRODUCT_READ}>
				<ProductCategoriesPage />
			</RequirePermission>
		),
	},
]

/** Child of the `/t/:slug/admin` route. */
export const localeSettingsRoute: RouteObject = {
	path: 'locale-settings',
	element: (
		<RequirePermission permission={Permission.TENANT_MANAGE_SETTINGS}>
			<LocaleSettingsPage />
		</RequirePermission>
	),
}

/** Child of the `/admin` route: the navigation entry that resolves the slug. */
export const localeSettingsRedirectRoute: RouteObject = {
	path: 'locale-settings',
	element: (
		<RequirePermission permission={Permission.TENANT_MANAGE_SETTINGS}>
			<LocaleSettingsRedirect />
		</RequirePermission>
	),
}

/** The product routes as absolute trees (used by the page tests). */
export const productRoutes: RouteObject[] = [
	{ path: '/', children: productPageRoutes },
	{ path: '/t/:slug/admin', children: [localeSettingsRoute] },
	{ path: '/admin', children: [localeSettingsRedirectRoute] },
]
